class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('atcpopup');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.continueShp = document.getElementById('popup-continue');

    var modalATC = document.getElementById('atcpopup');

    this.continueShp.addEventListener('click', function () {
      if (modalATC) {
        modalATC.style.display = 'none';
      }
    });

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    //When the user clicks anywhere outside of the modal, close it
    window.addEventListener('click', function (event) {
      if (event.target == modalATC) {
        modalATC.style.display = 'none';
      }
    });
  }

  open() {
    this.notification.style.display = 'block';
    this.notification.focus();
  }

  close() {
    this.notification.style.display = 'none';
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    const wrapperqtyprice = document.createElement('div');
    wrapperqtyprice.className = 'product-money-wrapper';
    const productQty = document.createElement('p');
    productQty.className = 'product-qty';
    productQty.textContent = 'Qty:' + parsedState.quantity;
    var customCurrency = window.shopcurrency;
    const productSmoney = document.createElement('p');
    productSmoney.className = 'product-smoney';
    productSmoney.textContent = customCurrency + parsedState.price / 100;
    // Add line-through style directly in JavaScript
    productSmoney.style.textDecoration = 'line-through';

    const productMoney = document.createElement('p');
    productMoney.className = 'product-money';
    productMoney.textContent = customCurrency + parsedState.final_price / 100;

    if (parseInt(parsedState.quantity) > 1) {
      wrapperqtyprice.appendChild(productQty);
    }

    // Check if productSmoney and productMoney have the same text content
    if (productSmoney.textContent === productMoney.textContent) {
      // Only display productMoney
      wrapperqtyprice.appendChild(productMoney);
    } else {
      // Display both productSmoney and productMoney
      wrapperqtyprice.appendChild(productSmoney);
      wrapperqtyprice.appendChild(productMoney);
    }

    const productDetails = document.querySelector('#cart-notification-product div dl');
    const productOptions = productDetails.querySelectorAll('.product-option');

    productOptions.forEach((option) => {
      const dt = option.querySelector('dt');
      if (dt && dt.textContent.trim() === 'PrivateSale:') {
        option.remove();
      }
    });

    if (parsedState.product_type && parsedState.product_type == 'Gift') {
      productDetails.innerHTML = '';
    }

    productDetails.parentNode.insertBefore(wrapperqtyprice, productDetails.nextSibling);

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-popup')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-popup', CartNotification);
